
import Validator from './Validator';

import { find } from 'lodash';
import { getInstance } from '../lib/component';
import { addListener } from '../lib/event';

export default class Form {

  constructor ($el) {
    this.$el = $el;

    // collect validators
    this.$validators = [].slice.call($el.querySelectorAll('[data-validator]'));

    // get validator instances from elements
    this.validators = this.$validators.map($input => {
      return getInstance(Validator, $input);
    });

    // inject self into validators
    this.validators.forEach(validator => validator.setForm(this));

    // bind events
    addListener(this.$el, 'submit', this.onSubmit.bind(this));

    const errorInput = this.$el.querySelector('.has-errors input,.has-errors select,.has-errors textarea');
    if (errorInput) {

      errorInput.focus();
    }
  }

  onSubmit (evt) {
    // ask fields to revalidate
    this.validators.forEach(validator => validator.revalidate());

    // find first invalid field
    const unsatisfiedValidator =
      find(this.validators, validator => !validator.isValid());

    if (unsatisfiedValidator !== undefined) {
      // prevent submit
      evt.preventDefault();

      // show validation state on all embedded fields
      this.validators.forEach(validator => validator.setHideValidation(false));

      // jump to the first invalid field
      unsatisfiedValidator.$el.focus();
      return false;
    }
  }
}

